import GridList, { type GridListComponentMapProps } from "@client/content/controls/GridList/component";
import { type RootContainerProps } from "@client/content/types";
import { identity } from "lodash";
import * as React from "react";
import { type EventItemProps } from "./Event/component";

export type MapProps = RootContainerProps & {
  gridProps: GridListComponentMapProps<EventItemProps>;
};
export interface ActionProps {}
export type Props = ActionProps & MapProps;

export default (props: Props) => <GridList {...props.gridProps} load={identity} />;
